// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"666":"1522b537","1436":"f24d702d","4787":"cd843b92"}[chunkId] + ".chunk.css";
};